import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography, CircularProgress } from '@mui/material';

interface GameExpiredRedirectProps {
  onRedirect?: () => void;
}

const GameExpiredRedirect: React.FC<GameExpiredRedirectProps> = ({ onRedirect }) => {
  const { t } = useTranslation();
  
  useEffect(() => {
    const redirectUrl = import.meta.env.VITE_END_ACTIVATE_URL;
    
    // console.log('🔍 GameExpiredRedirect: redirectUrl =', redirectUrl);
    
    if (redirectUrl) {
      // Вызываем callback перед редиректом
      if (onRedirect) {
        onRedirect();
      }
      
      // console.log('🔍 GameExpiredRedirect: Will redirect to', redirectUrl, 'in 2 seconds');
      
      // Небольшая задержка для показа сообщения
      setTimeout(() => {
        // console.log('🔍 GameExpiredRedirect: Executing redirect to', redirectUrl);
        window.location.href = redirectUrl;
      }, 2000);
    } else {
      console.error('VITE_END_ACTIVATE_URL не настроен в переменных окружения');
    }
  }, [onRedirect]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        textAlign: 'center',
        padding: '20px',
        backgroundColor: '#f5f5f5'
      }}
    >
      <CircularProgress size={60} sx={{ marginBottom: 3 }} />
      <Typography variant="h5" sx={{ marginBottom: 2, color: '#d32f2f' }}>
        {t('game.expired.title', 'Срок действия игры истек')}
      </Typography>
      <Typography variant="body1" sx={{ marginBottom: 3, color: '#666' }}>
        {t('game.expired.message', 'Перенаправление на главную страницу...')}
      </Typography>
    </Box>
  );
};

export default GameExpiredRedirect; 